import { transitionStatusMapping } from "../internals/stateAttributesMapping.js";
import { anchorHidden, open, closed } from "./CommonPopupDataAttributes.js";
import { popupOpen, pressed } from "./CommonTriggerDataAttributes.js";
const TRIGGER_HOOK = {
  [popupOpen]: ""
};
const PRESSABLE_TRIGGER_HOOK = {
  [popupOpen]: "",
  [pressed]: ""
};
const POPUP_OPEN_HOOK = {
  [open]: ""
};
const POPUP_CLOSED_HOOK = {
  [closed]: ""
};
const ANCHOR_HIDDEN_HOOK = {
  [anchorHidden]: ""
};
const triggerOpenStateMapping = {
  open(value) {
    if (value) {
      return TRIGGER_HOOK;
    }
    return null;
  }
};
const pressableTriggerOpenStateMapping = {
  open(value) {
    if (value) {
      return PRESSABLE_TRIGGER_HOOK;
    }
    return null;
  }
};
const popupStateMapping = {
  open(value) {
    if (value) {
      return POPUP_OPEN_HOOK;
    }
    return POPUP_CLOSED_HOOK;
  },
  anchorHidden(value) {
    if (value) {
      return ANCHOR_HIDDEN_HOOK;
    }
    return null;
  }
};
const popupTransitionStateMapping = {
  ...popupStateMapping,
  ...transitionStatusMapping
};
export {
  popupStateMapping,
  popupTransitionStateMapping,
  pressableTriggerOpenStateMapping,
  triggerOpenStateMapping
};
//# sourceMappingURL=popupStateMapping.js.map
